import React, { useState, useContext, createContext, FC, PropsWithChildren, useEffect } from 'react'

interface UserContextCar {
  idCar: number
  setIdCar: (idCar: number) => void
}

interface UserContextReservaHeader {
  idReservaHeader: number
  setIdReservaHeader: (idReservaHeader: number) => void
}

interface UserContextCotizacionC {
  idCotizacionC: number
  setIdCotizacionC: (idCotizacionC: number) => void
  editState: boolean
  setEditState: (editState: boolean) => void
  totalNochesC: number
  setTotalNochesC: (totalNoches: number) => void
}

interface UserContextPedidoC {
  idPedidoC: number
  setIdPedidoC: (idPedidoC: number) => void
  editState: boolean
  setEditState: (editState: boolean) => void
  totalNochesP: number
  setTotalNochesP: (totalNoches: number) => void
}
interface UserContextPedidoP {
  idPedidoP: number
  setIdPedidoP: (idPedidoP: number) => void
}

interface UserContextFlag {
  idFlag: boolean
  setIdFlag: (idFlag: boolean) => void
}

interface UserContextSociedad {
  idSociedad: string
  setIdSociedad: (idSociedad: string) => void
}

interface UserContextCategoriaRecurso {
  idCategoriaRecurso: string
  setIdCategoriaRecurso: (idCategoriaRecurso: string) => void
}

interface UserContextOrgVentas {
  idOrgVentas: string
  setIdOrgVentas: (idOrgVentas: string) => void
}

interface UserContextOfVentas {
  idOfVentas: string
  setIdOfVentas: (idOfVentas: string) => void
}

interface UserContextEsqEstatus {
  idEsqEstatus: string
  setIdEsqEstatus: (idEsqEstatus: string) => void
}

interface UserContextSector {
  idSector: string
  setIdSector: (idSector: string) => void
}

interface UserContextFAQ {
  idFAQ: number
  setIdFAQ: (idFAQ: number) => void
}

interface UserContextGrpConsentimiento {
  idGrpConsentimiento: number
  setIdGrpConsentimiento: (idGrpConsentimiento: number) => void
}

interface UserContextConsentimiento {
  idConsentimiento: number
  setIdConsentimiento: (idConsentimiento: number) => void
}

interface UserContextClienteEmpresarial {
  idClienteEmpresarial: number
  setIdClienteEmpresarial: (idClienteEmpresarial: number) => void
}
interface UserContextClientePersona {
  idClientePersona: number
  setIdClientePersona: (idClientePersona: number) => void
}
interface UserContextContacto {
  idContacto: number
  setIdContacto: (idContacto: number) => void
}

interface UserContextOrgSaas {
  idOrgSaas: number
  setIdOrgSaas: (idOrgSaas: number) => void
}

interface UserContextDocumento {
  idDocumento: number
  setIdDocumento: (idDocumento: number) => void
}

interface UserContextPais {
  idPais: string
  setIdPais: (idPais: string) => void
}

interface UserContextUsuario {
  idUsuario: number
  setIdUsuario: (idUsuario: number) => void
}
interface UserContextIdAplicativoOV {
  idAplicativoOV: number
  setIdAplicativoOV: (idAplicativoOV: number) => void
}

const userContextCar = createContext<UserContextCar>({ idCar: 0, setIdCar: () => { } })
const userContextReservaHeader = createContext<UserContextReservaHeader>({
  idReservaHeader: 0,
  setIdReservaHeader: () => { },
})

const userContextCotizacionC = createContext<UserContextCotizacionC>({
  idCotizacionC: 0,
  setIdCotizacionC: () => { },
  editState: false,
  setEditState: () => { },
  totalNochesC: 0,
  setTotalNochesC: () => { },
})
const userContextPedidoC = createContext<UserContextPedidoC>({
  idPedidoC: 0,
  setIdPedidoC: () => { },
  editState: false,
  setEditState: () => { },
  totalNochesP: 0,
  setTotalNochesP: () => { },
})
const userContextPedidoP = createContext<UserContextPedidoP>({
  idPedidoP: 0,
  setIdPedidoP: () => { },
})

const userContextFlag = createContext<UserContextFlag>({ idFlag: false, setIdFlag: () => { } })

const userContextSociedad = createContext<UserContextSociedad>({
  idSociedad: '',
  setIdSociedad: () => { },
})

const userContextCategoriaRecurso = createContext<UserContextCategoriaRecurso>({
  idCategoriaRecurso: '',
  setIdCategoriaRecurso: () => { },
})

const userContextOrgVentas = createContext<UserContextOrgVentas>({
  idOrgVentas: '',
  setIdOrgVentas: () => { },
})

const userContextOfVentas = createContext<UserContextOfVentas>({
  idOfVentas: '',
  setIdOfVentas: () => { },
})

const userContextEsqEstatus = createContext<UserContextEsqEstatus>({
  idEsqEstatus: '',
  setIdEsqEstatus: () => { },
})

const userContextSector = createContext<UserContextSector>({
  idSector: '',
  setIdSector: () => { },
})

const userContextFAQ = createContext<UserContextFAQ>({ idFAQ: 0, setIdFAQ: () => { } })

const userContextGrpConsentimiento = createContext<UserContextGrpConsentimiento>({
  idGrpConsentimiento: 0,
  setIdGrpConsentimiento: () => { },
})

const userContextConsentimiento = createContext<UserContextConsentimiento>({
  idConsentimiento: 0,
  setIdConsentimiento: () => { },
})

const userContextClienteEmpresarial = createContext<UserContextClienteEmpresarial>({
  idClienteEmpresarial: 0,
  setIdClienteEmpresarial: () => { },
})
const userContextClientePersona = createContext<UserContextClientePersona>({
  idClientePersona: 0,
  setIdClientePersona: () => { },
})
const userContextContacto = createContext<UserContextContacto>({
  idContacto: 0,
  setIdContacto: () => { },
})

const userContextOrgSaas = createContext<UserContextOrgSaas>({
  idOrgSaas: 0,
  setIdOrgSaas: () => { },
})

const userContextDocumento = createContext<UserContextDocumento>({
  idDocumento: 0,
  setIdDocumento: () => { },
})

const userContextPais = createContext<UserContextPais>({
  idPais: '',
  setIdPais: () => { },
})

const userContextUsuario = createContext<UserContextUsuario>({
  idUsuario: 0,
  setIdUsuario: () => { },
})

const userContextIdAplicativoOV = createContext<UserContextIdAplicativoOV>({
  idAplicativoOV: 0,
  setIdAplicativoOV: () => { },
})

export function useContextCar() {
  return useContext(userContextCar)
}

export function useContextReservaHeader() {
  return useContext(userContextReservaHeader)
}

export function useContextCotizacionC() {
  return useContext(userContextCotizacionC)
}
export function useContextPedidoC() {
  return useContext(userContextPedidoC)
}
export function useContextPedidoP() {
  return useContext(userContextPedidoP)
}

export function useContextFlag() {
  return useContext(userContextFlag)
}

export function useContextSociedad() {
  return useContext(userContextSociedad)
}

export function useContextCategoriaRecurso() {
  return useContext(userContextCategoriaRecurso)
}

export function useContextOrgVentas() {
  return useContext(userContextOrgVentas)
}

export function useContextOfVentas() {
  return useContext(userContextOfVentas)
}

export function useContextEsqEstatus() {
  return useContext(userContextEsqEstatus)
}

export function useContextSector() {
  return useContext(userContextSector)
}

export function useContextFAQ() {
  return useContext(userContextFAQ)
}

export function useContextGrpConsentimiento() {
  return useContext(userContextGrpConsentimiento)
}

export function useContextConsentimiento() {
  return useContext(userContextConsentimiento)
}

export function useContextClienteEmpresarial() {
  return useContext(userContextClienteEmpresarial)
}
export function useContextClientePersona() {
  return useContext(userContextClientePersona)
}
export function useContextContacto() {
  return useContext(userContextContacto)
}

export function useContextOrgSaas() {
  return useContext(userContextOrgSaas)
}

export function useContextDocumento() {
  return useContext(userContextDocumento)
}

export function useContextPais() {
  return useContext(userContextPais)
}

export function useContextUsuario() {
  return useContext(userContextUsuario)
}

export function useContextIdAplicativoOV() {
  return useContext(userContextIdAplicativoOV)
}

export const DataContext: FC<PropsWithChildren<{}>> = (props) => {
  const [idCar, setIdCar] = useState<number>(0)
  const [idReservaHeader, setIdReservaHeader] = useState<number>(0)

  const [idCotizacionC, setIdCotizacionC] = useState<number>(0)
  const [editState, setEditState] = useState<boolean>(false)
  const [idPedidoC, setIdPedidoC] = useState<number>(0)
  const [idPedidoP, setIdPedidoP] = useState<number>(0)

  const [totalNochesC, setTotalNochesC] = useState<number>(0)
  const [totalNochesP, setTotalNochesP] = useState<number>(0)

  const [idFlag, setIdFlag] = useState<boolean>(false)

  const [idSociedad, setIdSociedad] = useState<string>('')
  const [idCategoriaRecurso, setIdCategoriaRecurso] = useState<string>('')
  const [idOrgVentas, setIdOrgVentas] = useState<string>('')
  const [idOfVentas, setIdOfVentas] = useState<string>('')
  const [idEsqEstatus, setIdEsqEstatus] = useState<string>('')
  const [idSector, setIdSector] = useState<string>('')
  const [idFAQ, setIdFAQ] = useState<number>(0)
  const [idGrpConsentimiento, setIdGrpConsentimiento] = useState<number>(0)
  const [idConsentimiento, setIdConsentimiento] = useState<number>(0)

  const [idClienteEmpresarial, setIdClienteEmpresarial] = useState<number>(0)
  const [idClientePersona, setIdClientePersona] = useState<number>(0)
  const [idContacto, setIdContacto] = useState<number>(0)
  const [idOrgSaas, setIdOrgSaas] = useState<number>(0)
  const [idDocumento, setIdDocumento] = useState<number>(0)
  const [idPais, setIdPais] = useState<string>('')
  const [idUsuario, setIdUsuario] = useState<number>(0)
  const [idAplicativoOV, setIdAplicativoOV] = useState<number>(0)

  useEffect(() => {
    const storedDataCar = localStorage.getItem('idCar')
    if (storedDataCar) {
      const parsedData = parseInt(storedDataCar)
      setIdCar(parsedData)
    }
    const storedDataReservaHeader = localStorage.getItem('idReservaHeader')
    if (storedDataReservaHeader) {
      const parsedData = parseInt(storedDataReservaHeader)
      setIdReservaHeader(parsedData)
    }

    const storedDataCotizacionC = localStorage.getItem('idCotizacionC')
    if (storedDataCotizacionC) {
      const parsedData = parseInt(storedDataCotizacionC)
      setIdCotizacionC(parsedData)
    }
    const storedDataPedidoC = localStorage.getItem('idPedidoC')
    if (storedDataPedidoC) {
      const parsedData = parseInt(storedDataPedidoC)
      setIdPedidoC(parsedData)
    }
    const storedDataPedidoP = localStorage.getItem('idPedidoP')
    if (storedDataPedidoP) {
      const parsedData = parseInt(storedDataPedidoP)
      setIdPedidoP(parsedData)
    }

    const storedDataFlag = localStorage.getItem('idFlag')
    if (storedDataFlag) {
      setIdFlag(storedDataFlag === 'true')
    }

    const storedDataSociedad = localStorage.getItem('idSociedad')
    if (storedDataSociedad) {
      setIdSociedad(storedDataSociedad)
    }

    const storedDataCategoriaRecurso = localStorage.getItem('idCategoriaRecurso')
    if (storedDataCategoriaRecurso) {
      setIdCategoriaRecurso(storedDataCategoriaRecurso)
    }

    const storedDataOrgVentas = localStorage.getItem('idOrgVentas')
    if (storedDataOrgVentas) {
      setIdOrgVentas(storedDataOrgVentas)
    }

    const storedDataOfVentas = localStorage.getItem('idOfVentas')
    if (storedDataOfVentas) {
      setIdOfVentas(storedDataOfVentas)
    }

    const storedDataEsqEstatus = localStorage.getItem('idEsqEstatus')
    if (storedDataEsqEstatus) {
      setIdEsqEstatus(storedDataEsqEstatus)
    }

    // const storedDataSector = localStorage.getItem('idSector')
    // if (storedDataSector) {
    //   const parsedData = storedDataSector
    //   console.log(storedDataSector);
    //   setIdSector(parsedData)
    // }

    const storedDataSector = localStorage.getItem('idSector')
    if (storedDataSector) {
      setIdSector(storedDataSector)
    }

    const storedDataFAQ = localStorage.getItem('idFAQ')
    if (storedDataFAQ) {
      const parsedData = parseInt(storedDataFAQ)
      setIdFAQ(parsedData)
    }

    const storedDataGrpConsentimiento = localStorage.getItem('idGrpConsentimiento')
    if (storedDataGrpConsentimiento) {
      const parsedData = parseInt(storedDataGrpConsentimiento)
      setIdGrpConsentimiento(parsedData)
    }

    const storedDataConsentimiento = localStorage.getItem('idConsentimiento')
    if (storedDataConsentimiento) {
      const parsedData = parseInt(storedDataConsentimiento)
      setIdConsentimiento(parsedData)
    }

    const storedDataClienteEmpresarial = localStorage.getItem('idClienteEmpresarial')
    if (storedDataClienteEmpresarial) {
      const parsedData = parseInt(storedDataClienteEmpresarial)
      setIdClienteEmpresarial(parsedData)
    }
    const storedDataClientePersona = localStorage.getItem('idClientePersona')
    if (storedDataClientePersona) {
      const parsedData = parseInt(storedDataClientePersona)
      setIdClientePersona(parsedData)
    }
    const storedDataContacto = localStorage.getItem('idContacto')
    if (storedDataContacto) {
      const parsedData = parseInt(storedDataContacto)
      setIdContacto(parsedData)
    }

    const storedDataOrgSaas = localStorage.getItem('idOrgSaas')
    if (storedDataOrgSaas) {
      const parsedData = parseInt(storedDataOrgSaas)
      setIdOrgSaas(parsedData)
    }

    const storedDataDocumento = localStorage.getItem('idDocumento')
    if (storedDataDocumento) {
      const parsedData = parseInt(storedDataDocumento)
      setIdDocumento(parsedData)
    }

    const storedDataPais = localStorage.getItem('idPais')
    if (storedDataPais) {
      setIdPais(storedDataPais)
    }

    const storedDataUsuario = localStorage.getItem('idUsuario')
    if (storedDataUsuario) {
      const parsedData = parseInt(storedDataUsuario)
      setIdUsuario(parsedData)
    }

    const storedDataAplicativoOV = localStorage.getItem('idAplicativoOV')
    if (storedDataAplicativoOV) {
      const parsedData = parseInt(storedDataAplicativoOV)
      setIdAplicativoOV(parsedData)
    }
  }, [])

  return (
    <userContextCar.Provider value={{ idCar, setIdCar }}>
      <userContextSociedad.Provider value={{ idSociedad, setIdSociedad }}>
        <userContextOrgVentas.Provider value={{ idOrgVentas, setIdOrgVentas }}>
          <userContextOfVentas.Provider value={{ idOfVentas, setIdOfVentas }}>
            <userContextEsqEstatus.Provider value={{ idEsqEstatus, setIdEsqEstatus }}>
              <userContextSector.Provider value={{ idSector, setIdSector }}>
                <userContextFAQ.Provider value={{ idFAQ, setIdFAQ }}>
                  <userContextGrpConsentimiento.Provider
                    value={{ idGrpConsentimiento, setIdGrpConsentimiento }}
                  >
                    <userContextClienteEmpresarial.Provider
                      value={{ idClienteEmpresarial, setIdClienteEmpresarial }}
                    >
                      <userContextClientePersona.Provider
                        value={{ idClientePersona, setIdClientePersona }}
                      >
                        <userContextContacto.Provider value={{ idContacto, setIdContacto }}>
                          <userContextOrgSaas.Provider value={{ idOrgSaas, setIdOrgSaas }}>
                            <userContextDocumento.Provider value={{ idDocumento, setIdDocumento }}>
                              <userContextPais.Provider value={{ idPais, setIdPais }}>
                                <userContextUsuario.Provider value={{ idUsuario, setIdUsuario }}>
                                  <userContextConsentimiento.Provider
                                    value={{ idConsentimiento, setIdConsentimiento }}
                                  >
                                    <userContextFlag.Provider value={{ idFlag, setIdFlag }}>
                                      <userContextIdAplicativoOV.Provider
                                        value={{ idAplicativoOV, setIdAplicativoOV }}
                                      >
                                        <userContextReservaHeader.Provider
                                          value={{ idReservaHeader, setIdReservaHeader }}
                                        >
                                          <userContextCotizacionC.Provider
                                            value={{ idCotizacionC, setIdCotizacionC, editState, setEditState, totalNochesC, setTotalNochesC }}
                                          >
                                            <userContextPedidoC.Provider
                                              value={{ idPedidoC, setIdPedidoC, editState, setEditState, totalNochesP, setTotalNochesP }}
                                            >
                                              <userContextPedidoP.Provider
                                                value={{ idPedidoP, setIdPedidoP }}
                                              >
                                                <userContextCategoriaRecurso.Provider
                                                  value={{
                                                    idCategoriaRecurso,
                                                    setIdCategoriaRecurso,
                                                  }}
                                                >
                                                  {props.children}
                                                </userContextCategoriaRecurso.Provider>
                                              </userContextPedidoP.Provider>
                                            </userContextPedidoC.Provider>
                                          </userContextCotizacionC.Provider>
                                        </userContextReservaHeader.Provider>
                                      </userContextIdAplicativoOV.Provider>
                                    </userContextFlag.Provider>
                                  </userContextConsentimiento.Provider>
                                </userContextUsuario.Provider>
                              </userContextPais.Provider>
                            </userContextDocumento.Provider>
                          </userContextOrgSaas.Provider>
                        </userContextContacto.Provider>
                      </userContextClientePersona.Provider>
                    </userContextClienteEmpresarial.Provider>
                  </userContextGrpConsentimiento.Provider>
                </userContextFAQ.Provider>
              </userContextSector.Provider>
            </userContextEsqEstatus.Provider>
          </userContextOfVentas.Provider>
        </userContextOrgVentas.Provider>
      </userContextSociedad.Provider>
    </userContextCar.Provider>
  )
}
